module.exports = __webpack_public_path__ + "static/media/demat3.fae7f037.svg";